module.exports = __webpack_public_path__ + "static/media/fcmb.ddf2b3db.svg";